import React, { memo, useCallback, useState } from 'react';
import clsx from 'clsx';
import $ from 'jquery';

const SEARCH_ADDRESS_URL = '/api/v1/PostCode';

const AddressAutocomplete = memo(({ value: initialValue, placeholder, onChange, onBlur = () => { }, sortBy = 'postcode', isValid = true }) => {
    const [addresses, setAddresses] = useState([]);
    const [value, onChangeInput] = useState(initialValue || '');

    const _onChange = ({ target: { value: _value } }) => {
        onChangeInput(_value);
        if (!_value) return setAddresses([]);

        $.ajax({
            url: `${SEARCH_ADDRESS_URL}/Search?query=${_value}`,
            type: 'Get',
            success: (d) => {
                setAddresses(d.sort((a, b) => (a[sortBy] > b[sortBy] ? 1 : -1)));
            },
            error: (e) => {
                console.error(e);
            },
        });
    };

    const _onSelect = (_value, inputValue) => () => {

        $.ajax({
            url: `${SEARCH_ADDRESS_URL}/Retrieve`,
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify({
                id:_value.id,
                query: inputValue
            }),
            success: (d) => {
                onChange(d);
                onChangeInput(inputValue);
                setAddresses([]);
            },
            error: (e) => {
                console.error(e);
            },
        });
    };

    return (
        <div className="signup-form__autocomplete">
            <input
                onBlur={onBlur()}
                type="text"
                value={value}
                placeholder={placeholder}
                className={clsx('signup-form__row', 'signup-form__input', {
                    ['signup-form__input-error']: !isValid,
                })}
                onChange={_onChange}
                autoComplete='new-password'
            />
            {!!addresses.length && (
                <div className="signup-form__autocomplete-list">
                    {addresses.map(({ fullSummary, id = [] }, idx) => {
                        const _value = `${fullSummary}`;
                        const selectedAddress = { fullSummary, id };
                        return (
                            <div
                                key={`${_value}_${idx}`}
                                onClick={_onSelect(selectedAddress, _value)}
                                className="signup-form__autocomplete-list-item"
                            >
                                {_value}
                            </div>
                        );
                    })}
                </div>
            )}
            {!isValid && <span className="signup-form__error-message">Required field</span>}
        </div>
    );
});

export default AddressAutocomplete;
